/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_WomenInputs */

const en_val_women = /** @type {(inputs: Val_WomenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Women`)
};

const es_val_women = /** @type {(inputs: Val_WomenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mujeres`)
};

const fr_val_women = /** @type {(inputs: Val_WomenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Femmes`)
};

const de_val_women = /** @type {(inputs: Val_WomenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Damen`)
};

const ja_val_women = /** @type {(inputs: Val_WomenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レディース`)
};

const zh_val_women = /** @type {(inputs: Val_WomenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`女装`)
};

const ar_val_women = /** @type {(inputs: Val_WomenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نسائي`)
};

const id_val_women = /** @type {(inputs: Val_WomenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wanita`)
};

const it_val_women = /** @type {(inputs: Val_WomenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Donna`)
};

const ru_val_women = /** @type {(inputs: Val_WomenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Женщинам`)
};

const pt_val_women = /** @type {(inputs: Val_WomenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feminino`)
};

const ko_val_women = /** @type {(inputs: Val_WomenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`여성용`)
};

/**
* | output |
* | --- |
* | "Women" |
*
* @param {Val_WomenInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_women = /** @type {((inputs?: Val_WomenInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_WomenInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_women(inputs)
	if (locale === "es") return es_val_women(inputs)
	if (locale === "fr") return fr_val_women(inputs)
	if (locale === "de") return de_val_women(inputs)
	if (locale === "ja") return ja_val_women(inputs)
	if (locale === "zh") return zh_val_women(inputs)
	if (locale === "ar") return ar_val_women(inputs)
	if (locale === "id") return id_val_women(inputs)
	if (locale === "it") return it_val_women(inputs)
	if (locale === "ru") return ru_val_women(inputs)
	if (locale === "pt") return pt_val_women(inputs)
	return ko_val_women(inputs)
});